if (!customElements.get('multi-buy')) {
  class MultiBuy extends HTMLElement {
    constructor() {
      super();
      this.quantitySelector = document.querySelector('.quantity-selector');
      this.submitContainer = document.querySelector('.submit-button-container');

      this.totalQty = parseInt(this.getKnickerCartQty());
      this.updatePdpBtnPrice()
        if (this.submitContainer.getAttribute("data-active") === "true") {
          this.calculateProgress(this.totalQty + 1)
        }
        else {
          this.calculateProgress(this.totalQty)
        }
      
      this.self = this;

      // window.addEventListener('cart_rendered', (event)=> {
      //   // this.multiBuyCartHeader()
      //   this.quantitySelector = document.querySelector('.quantity-selector');
      //   this.totalQty = parseInt(this.getKnickerCartQty());
      //   const qtySelector = document.querySelector('.quantity-selector');
      //   const qtyNumber = document.querySelector('.quantity-number');
      //   // qtySelector.value = 1;
      //   // qtyNumber.textContent = 1;
      //   this.calculateProgress(this.totalQty + parseInt(qtySelector.value))
      //   this.updatePdpBtnPrice()
      // })

      window.addEventListener('cart_rendered', (event)=> {
  this.quantitySelector = document.querySelector('.quantity-selector');
  this.totalQty = parseInt(this.getKnickerCartQty(), 10) || 0;
  const qtySelector = document.querySelector('.quantity-selector');
    this.calculateProgress(this.totalQty + parseInt(qtySelector.value, 10));
    this.toasterCalculateProgress(this.totalQty);
  this.updatePdpBtnPrice();
});


      window.addEventListener('quantity-selector-changed', (event)=> {
        const multiBuy = document.querySelector('multi-buy')
        if(multiBuy.classList.contains('is-hidden')) return;
        this.updatePdpBtnPrice()  
          this.calculateProgress(this.totalQty + parseInt(event.detail.value));
      })

    }

    // getCartTotal() {
    //   // fetch(`${window.location.origin}/cart.js`)
    //   // .then(response => response.json)
    //   const subTotal = document.querySelector('[data-sub-total]')?.dataset.subTotal || this.dataset.cartSubtotal;
    //   return subTotal;
    // }

    updatePdpPrice(price = 0) {
      if(this.classList.contains('is-hidden')) return;
      const currencySymbol = this.dataset.currencySymbol || '£';
      const pdpPrice = document.querySelector('.variant-price-wrapper:not(.hidden) .product-price.heading-md');
      const priceWrapper = document.querySelector('.variant-price-wrapper:not(.hidden)');
      let priceNode;
      if(document.querySelector('.swatch_wrapper.current')) {
        priceNode = parseFloat(document.querySelector('.swatch_wrapper.current').dataset.rawPrice).toFixed(2);
      }
      const priceMilestone = parseFloat(price).toFixed(2);
      if (priceNode === priceMilestone || price === 0) {
        pdpPrice.textContent = currencySymbol + priceNode.replace('.00', '');
        document?.querySelector('.dynamic-sale-price')?.classList.add('is-hidden');
        return;
      }
      const productSalePrice = document.querySelector('.dynamic-sale-price') || document.createElement('span');
      productSalePrice.classList.add('product-sale-price', 'strikethrough', 'dynamic-sale-price');
      productSalePrice.classList.remove('is-hidden');
      productSalePrice.textContent = currencySymbol + priceNode?.replace('.00', '');
      if(pdpPrice) {
        pdpPrice.textContent = currencySymbol + priceMilestone.replace('.00', '');
        priceWrapper.prepend(productSalePrice);
      }
    }

    updatePdpBtnPrice(isCartEmpty = false) {
      if(this.classList.contains('is-hidden')) return;
      const pdpBtnPrice = document.querySelector('.submit-button.button-2 .multi-buy-price');
      if(!pdpBtnPrice) return;
      const quantitySelector = document.querySelector('.quantity-selector');
      const qtyNumber = parseInt(quantitySelector.value)

      const cartQtyAndBtnQty = parseInt(this.getKnickerCartQty()) + qtyNumber;
      const allPills = this.querySelectorAll('.multi-buy-progress-pill');
      allPills.forEach((pill, index)=> {
        const milestoneQty = parseInt(pill.dataset.milestoneQty);
        const nextMilestoneQty = parseInt(allPills[index + 1]?.dataset.milestoneQty);
        if(cartQtyAndBtnQty >= milestoneQty) {

          const milestonePrice = parseFloat(pill.dataset.milestonePrice);
          const totalMultibuyPrice = qtyNumber * milestonePrice;
          const formattedPriceStr = pill.dataset.milestoneFormattedPrice || '';
          
          // Extract the numeric value from the formatted price string and replace with calculated total
          if (formattedPriceStr) {
            // Find the numeric part (handles formats like "Dhs. 92.00" or "£12.60" or "د.إ92.00")
            // Match number with optional commas and decimal part
            const numericMatch = formattedPriceStr.match(/[\d,]+\.?\d*/);
            if (numericMatch) {
              // Format the total price with 2 decimal places
              const totalStr = totalMultibuyPrice.toFixed(2);
              // Replace the numeric part in the formatted string, preserving the currency format
              const totalFormatted = formattedPriceStr.replace(/[\d,]+\.?\d*/, totalStr);
              
              // Update both data-price attribute and displayed text
              pdpBtnPrice.setAttribute('data-price', totalStr);
              pdpBtnPrice.textContent = totalFormatted;
            } else {
              // Fallback: if no match, use the calculated price as-is
              pdpBtnPrice.setAttribute('data-price', totalMultibuyPrice.toFixed(2));
              pdpBtnPrice.textContent = totalMultibuyPrice.toFixed(2);
            }
          } else {
            // Fallback to simple formatting
            pdpBtnPrice.setAttribute('data-price', totalMultibuyPrice.toFixed(2));
            pdpBtnPrice.textContent = totalMultibuyPrice.toFixed(2);
          }
        }
      })
    }

    getKnickerCartQty() {
      const totalQtyCart = document.querySelector('.total-knicker-qty')?.dataset.totalKnickerQty || this.dataset.totalKnickerQty;     
      return parseInt(totalQtyCart);
      }

    multiBuyCartHeader() {
      const multibuyCartItems = document.querySelectorAll('.multibuy-cart-item');
      if(multibuyCartItems.length === 0) return;
      const multiBuyHeader = document.createElement('div');
      multiBuyHeader.classList.add('multi-buy-header');
      multiBuyHeader.style.order = 1;
      multiBuyHeader.innerHTML = `<h4> <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="4.5" r="4" fill="currentColor"></circle></svg> Underwear Selector</h4> <h4 class="multi-buy-progress-text"></h4>`      
      multibuyCartItems[multibuyCartItems.length - 1].after(multiBuyHeader)
    }


    calculateProgress(totalQty) {
      const allPills = this.querySelectorAll('.multi-buy-progress-pill');
      const allProgressBars = this.querySelectorAll('.multi-buy-progress-bar');
      const milestoneTargetPrice = this.querySelector('.milestone-target-price');
      const milestoneTargetQty = this.querySelector('.milestone-target-qty');
      const multiBuyProgressTexts = document.querySelectorAll('.multi-buy-progress-text:not(.toaster-text)');
      if(totalQty === 0) {
        multiBuyProgressTexts.forEach((text, index)=> {
          text.textContent = `Add 3 more & save 30%`;
        })
      }



      allPills.forEach((pill, index)=> {
        const miletstoneQty = parseInt(pill.dataset.milestoneQty);
        const progressBar = pill.parentElement.nextElementSibling

        // if(totalQty === 0 ) {
        //   progressBar.querySelector('.multi-buy-progress-precentage').style.width = `0`
        //   return;
        // }

        if(miletstoneQty <= totalQty) {
          pill.classList.add('active');
          if(progressBar?.classList.contains('multi-buy-progress-bar')) {
            const nextMilestone = parseInt(allPills[index + 1]?.dataset.milestoneQty);
            const nextMilestonePrice = parseFloat(allPills[index + 1]?.dataset.milestonePrice).toFixed(2);
            const nextMilestonePercentage = parseInt(allPills[index + 1]?.dataset.milestonePercentage);
            const nextTargetMilestone =  nextMilestone - totalQty
            this.updatePdpPrice(pill.dataset.milestonePrice)
            if(nextTargetMilestone <= 0 ) {
              progressBar.querySelector('.multi-buy-progress-precentage').style.width = `100%`
              return;
            
            }
            console.log('Update PDP price')
            const nextMilestoneQty = nextMilestone - miletstoneQty;
            const perecentage = (1 - (nextTargetMilestone / nextMilestoneQty)) * 100;
            multiBuyProgressTexts.forEach((text, index)=> {
              text.textContent = `Add ${nextTargetMilestone} more & save ${nextMilestonePercentage}%`;
            })

            if(miletstoneQty === totalQty) {
              progressBar.querySelector('.multi-buy-progress-precentage').style.width = `0`
              return;
            }

            
            progressBar.querySelector('.multi-buy-progress-precentage').style.width = `${perecentage}%`
          }
        } else {
          pill.classList.remove('active');
          if(progressBar) {
            progressBar.querySelector('.multi-buy-progress-precentage').style.width = `0`
          }
        }
        if(allPills.length - 1 === index && pill.classList.contains('active')) {
          const finalPrice = parseFloat(pill?.dataset.milestonePrice).toFixed(2);
          const currentPercentage = parseInt(pill?.dataset.milestonePercentage);
          this.updatePdpPrice(finalPrice)

          multiBuyProgressTexts.forEach((text, index)=> {
            text.textContent = `You're saving ${currentPercentage}%`;
          })
        }

      })
    }
    toasterCalculateProgress(totalQty) {
      const allPills = this.querySelectorAll('.multi-buy-progress-pill');
      const multiBuyProgressTexts = document.querySelectorAll('.multi-buy-progress-text.toaster-text');
      if(totalQty === 0) {
        multiBuyProgressTexts.forEach((text, index)=> {
          text.textContent = `Add 3 more & save 30%`;
        })
      }



      allPills.forEach((pill, index)=> {
        const miletstoneQty = parseInt(pill.dataset.milestoneQty);
        const progressBar = pill.parentElement.nextElementSibling

        // if(totalQty === 0 ) {
        //   progressBar.querySelector('.multi-buy-progress-precentage').style.width = `0`
        //   return;
        // }

        if(miletstoneQty <= totalQty) {
          pill.classList.add('active');
          if(progressBar?.classList.contains('multi-buy-progress-bar')) {
            const nextMilestone = parseInt(allPills[index + 1]?.dataset.milestoneQty);
            const nextMilestonePercentage = parseInt(allPills[index + 1]?.dataset.milestonePercentage);
            const nextTargetMilestone =  nextMilestone - totalQty
            this.updatePdpPrice(pill.dataset.milestonePrice)
            if(nextTargetMilestone <= 0 ) {
              progressBar.querySelector('.multi-buy-progress-precentage').style.width = `100%`
              return;
            
            }
            console.log('Update PDP price')
            const nextMilestoneQty = nextMilestone - miletstoneQty;
            const perecentage = (1 - (nextTargetMilestone / nextMilestoneQty)) * 100;
            multiBuyProgressTexts.forEach((text, index)=> {
              text.textContent = `Add ${nextTargetMilestone} more & save ${nextMilestonePercentage}%`;
            })

            if(miletstoneQty === totalQty) {
              progressBar.querySelector('.multi-buy-progress-precentage').style.width = `0`
              return;
            }

            
            progressBar.querySelector('.multi-buy-progress-precentage').style.width = `${perecentage}%`
          }
        } else {
          pill.classList.remove('active');
          if(progressBar) {
            progressBar.querySelector('.multi-buy-progress-precentage').style.width = `0`
          }
        }
        if(allPills.length - 1 === index && pill.classList.contains('active')) {
          const finalPrice = parseFloat(pill?.dataset.milestonePrice).toFixed(2);
          const currentPercentage = parseInt(pill?.dataset.milestonePercentage);
          this.updatePdpPrice(finalPrice)

          multiBuyProgressTexts.forEach((text, index)=> {
            text.textContent = `You're saving ${currentPercentage}%`;
          })
        }

      })
    }
  }  

  customElements.define('multi-buy', MultiBuy);
}
